import * as yup from "yup";

export const PROFILE_EDIT_FORM_SCHEMA = yup.object().shape({
  firstName: yup.string().nullable().required("Molimo unesite ime"),
  lastName: yup.string().nullable().required("Molimo unesite prezime"),
  email: yup
    .string()
    .nullable()
    .required("Molimo unesite email")
    .email("Neispravan email"),
});
